// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  name: 'dev',
  apiUrl: 'https://dev.teveni.app/api',
  firebaseConfig: {
    apiKey: 'AIzaSyAm6QbkK5Tt4d3dO8flfpzSJoi2wvr9n_g',
    authDomain: 'teveni-abd47.firebaseapp.com',
    projectId: 'teveni-abd47',
    storageBucket: 'teveni-abd47.firebasestorage.app',
    messagingSenderId: '120822819061',
    appId: '1:120822819061:web:31b8722f5c9b69dc62bdbc',
  },
  vapidPublicKey:
    'BGR5rfmjq1pESWTPQfc-H4taSbS-FXWQ_PQlecL7UBsQ1qT3yJnIlB0Y5wDVTxpfW7DaF16AeMiSDszLcTlTUok',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
